(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const headers = document.querySelectorAll('.section-header');
    const updateFilterOffset = () => {
      let height = 0;
      headers.forEach(header => {
        if (header.querySelector('sticky-header[class*="__desktop"]')) {
          height += header.getBoundingClientRect().height;
        }
      });
      document.documentElement.style.setProperty('--rr-filters-top', (Math.ceil(height) + 16) + 'px');
    };
    const observer = new ResizeObserver(updateFilterOffset);
    headers.forEach(header => observer.observe(header));
    updateFilterOffset();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-promo-bar"]) return;
  try {
    
  if (!customElements.get('rr-promo-copy')) {
    customElements.define('rr-promo-copy', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const button = this.querySelector('button');
        const label = this.querySelector('.rr-promo-copy-label');
        const input = this.querySelector('input');
        const original = label.textContent;
        button.addEventListener('click', async () => {
          clearTimeout(this.resetTimer);
          try {
            await navigator.clipboard.writeText(button.dataset.code);
            label.textContent = button.dataset.copied;
            button.classList.add('rr-code-copied');
            input.hidden = true;
            this.resetTimer = setTimeout(() => { label.textContent = original; button.classList.remove('rr-code-copied'); }, 3000);
          } catch {
            input.hidden = false;
            input.focus();
            input.select();
            label.textContent = button.dataset.fallback;
            button.classList.remove('rr-code-copied');
          }
        });
      }
      disconnectedCallback() { clearTimeout(this.resetTimer); }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
